import myAxios from "../utils/request";
export default {
  getActivityType() {
    return myAxios.get(`/api/activity/getactype`);
  },
  getActivityList(params) {
    return myAxios.post("/api/activity/getactivitylist", params);
  },
  getActivityInfo(params) {
    const { Id } = params;
    return myAxios.get(`/api/activity/getactivitybyid?acID=${Id}`);
  },
  batchDelete(params) {
    return myAxios.post("/api/activity/deleteac", params);
  },
  addData(params) {
    return myAxios.post("/api/activity/addactivity", params);
  },
  modifyData(params) {
    return myAxios.post("/api/activity/updateactivity", params);
  }
};
